export const TYPE_OPTS = ({ isActive } = {}) => {
  const renderDefault = {
    true: {
      text: 'text-brand-primary-base',
    },
    false: {
      text: 'text-muted',
    },
  };

  const renderDisabled = {
    text: '!text-disabled',
  };

  return {
    default: renderDefault?.[isActive],
    disabled: renderDisabled,
  };
};
